import type { ActiveInactive } from 'src/api';

export enum ConsumerVerificationPreferenceFormFields {
  isAutoVerificationRequestEnabled = 'isAutoVerificationRequestEnabled',
}

export type ConsumerVerificationPreferenceFormValues = {
  [ConsumerVerificationPreferenceFormFields.isAutoVerificationRequestEnabled]: ActiveInactive;
};
